import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise, AxiosRequestConfig } from 'axios'
import { ResponseData } from 'request'
import { MessageType, MessageListResponseData } from './index.type'

// 站内信列表
export function getMessageList(
  options: AxiosRequestConfig = {},
): AxiosPromise<ResponseData<MessageListResponseData>> {
  return request({
    url: `${v2Host}/message/list`,
    method: 'get',
    ...options,
  })
}

// 站内设置为已读
export function setMessageRead(
  msg_ids: {
    id: MessageType['msg_id']
    seq: MessageType['seq']
  }[],
): AxiosPromise<ResponseData<unknown>> {
  return request({
    url: `${v2Host}/message/read`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      msg_ids,
    },
  })
}
